module.exports = __webpack_public_path__ + "static/media/polaroid-10.2e0ab5a5.png";